import dayjs from 'dayjs'
import { useSelector } from 'react-redux'
import { TimesheetStoreState } from '../../store/timesheetStore'

export const useShouldSkipFilteredQuery = (): boolean => {
	const timesheetDetails = useSelector((state: TimesheetStoreState) => state.timesheetDetails)

	const SQL_MIN_DATE = dayjs('1753-01-01T00:00:00Z')
	const SQL_MAX_DATE = dayjs('9999-12-31T23:59:59Z')

	const { startDate, endDate } = timesheetDetails?.filters || {}

	const start = dayjs(startDate)
	const end = dayjs(endDate)

	const isStartInvalid = !start.isValid() || start.isBefore(SQL_MIN_DATE) || start.isAfter(SQL_MAX_DATE)
	const isEndInvalid = !end.isValid() || end.isBefore(SQL_MIN_DATE) || end.isAfter(SQL_MAX_DATE)

	return isStartInvalid || isEndInvalid
}
